import React, { useCallback, useEffect } from "react"
import { useDropzone } from "react-dropzone"
import { useTranslation } from "next-i18next"
import useViewport from "@/hooks/useViewport"
import { getTranslations } from "@/components/VisualSearch/localization"
import { IMAGE_FILE_TYPE } from "@/components/VisualSearch/v1/UploadImage/constant"
import { addDataLayerVisualSearch } from "@/components/VisualSearch/analytics"

const FileUpload = props => {
  const {
    setImage = () => {},
    setSection,
    setEventType = () => {},
    category,
  } = props

  const { t } = useTranslation()
  const device = useViewport()
  const { borwseBtn, imageUploadtext, changeProduct, imageUploadSubText } =
    getTranslations(t)
  let heic2any = null
  useEffect(() => {
    import("heic2any").then(module => {
      heic2any = module.default
    })
  }, [])
  const onDrop = useCallback(acceptedFiles => {
    let file = acceptedFiles[0]
    const heicType = ["image/heif", "image/heic"]
    const isHeicimg = heicType.includes(file?.type)
    if (isHeicimg) {
      heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.9,
      }).then(res => {
        file = new File([res], file.name, {
          type: res.type,
          lastModified: new Date().getTime(),
        })
        if (file) {
          reader.readAsDataURL(file)
        }
      })
    }
    const reader = new FileReader()

    reader.onload = event => {
      const img = new Image()
      img.onload = () => {
        setImage({ file, width: img.width, height: img.height })
      }
      img.src = event.target.result
    }

    if (!isHeicimg && file) {
      reader.readAsDataURL(file)
    }
  }, [])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })
  return (
    <>
      {!device?.isSmallTabView ? (
        <div className={`file-upload ${isDragActive ? "drag-container" : ""}`}>
          <div
            className="drag-wrapper"
            onDrop={() => {
              setEventType("drag an image here")
              addDataLayerVisualSearch({
                eventKey: "drag an image here",
                category: category,
                eventStatus: "interaction",
              })
            }}
          >
            <div
              {...getRootProps()}
              className={"file-upload-dropzone" + (isDragActive ? " drag" : "")}
            >
              {isDragActive ? (
                <p className="title-hover">{imageUploadtext}</p>
              ) : (
                <>
                  <p className="title">{imageUploadtext}</p>
                  <p className="seperator">{imageUploadSubText}</p>
                  <button
                    className="browse"
                    onClick={() => {
                      setEventType("browse")
                      addDataLayerVisualSearch({
                        eventKey: "browse",
                        category: category,
                        eventStatus: "interaction",
                      })
                    }}
                  >
                    {borwseBtn}
                  </button>
                  <input
                    {...getInputProps()}
                    accept={IMAGE_FILE_TYPE}
                    aria-label="Input Images"
                  />
                </>
              )}
            </div>
            {!isDragActive ? (
              <div className="product_change">
                <button
                  className="change-button"
                  onClick={() => {
                    setSection("category")
                    addDataLayerVisualSearch({
                      eventKey: `change product`,
                      category: category,
                    })
                  }}
                >
                  <p>{changeProduct}</p>
                </button>
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
    </>
  )
}

export default FileUpload
